import React from 'react';

function Hero() {
    const handleNavClick = (e, targetId) => {
        e.preventDefault();
        const target = document.querySelector(targetId);
        if (target) {
            const offsetTop = target.offsetTop - 80;
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });
        }
    };

    return (
        <section id="home" className="hero">
            <div className="hero-overlay"></div>
            <div className="container">
                <div className="hero-content">
                    <h1 className="hero-title animate-fade-in">
                        혁신적인 PCB 솔루션<br />
                        <span className="highlight">은혜테크</span>가 함께합니다
                    </h1>
                    <p className="hero-subtitle animate-fade-in-delay-1">
                        PCB 설계부터 양산까지, 소프트웨어 개발까지<br />
                        원스톱 솔루션을 제공하는 기술 파트너
                    </p>
                    <div className="hero-buttons animate-fade-in-delay-2">
                        <a href="#contact" className="btn btn-primary" onClick={(e) => handleNavClick(e, '#contact')}>
                            <i className="fas fa-paper-plane"></i> 문의하기
                        </a>
                        <a href="#about" className="btn btn-secondary" onClick={(e) => handleNavClick(e, '#about')}>
                            <i className="fas fa-info-circle"></i> 자세히 보기
                        </a>
                    </div>
                </div>
            </div>
            <div className="scroll-indicator">
                <i className="fas fa-chevron-down"></i>
            </div>
        </section>
    );
}

export default Hero;
